import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
import axios from 'axios'

export const getLinkInteractive = async id => {
    const response = await axios(
        `${PRESUPUESTADOR_ENDPOINT}/${id}/interactive/link`
    )
    return response?.data?.data
}
